import script from "./pay-rest-money.vue?vue&type=script&lang=ts&setup=true"
export * from "./pay-rest-money.vue?vue&type=script&lang=ts&setup=true"

import "./pay-rest-money.vue?vue&type=style&index=0&id=1228211e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1228211e"]])

export default __exports__